/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Move_Word_DownInputs */



/**
* | output |
* | --- |
* | "Move a single word down to the next line" |
*
* @param {Shortcut_Keys_Desc_Move_Word_DownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_move_word_down = /** @type {((inputs?: Shortcut_Keys_Desc_Move_Word_DownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Move_Word_DownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deplacer un mot vers la ligne suivante")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verschiebe ein einzelnes Wort in die nächste Zeile.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta una singola parola alla riga successiva")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместите одно слово на следующую строку.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mover una sola palabra a la siguiente línea")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将一个单词向下移动到下一行。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1つの単語を次の行に移動する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक शब्द को नीचे अगली पंक्ति में ले जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mova uma única palavra para a linha seguinte.")
	return /** @type {LocalizedString} */ ("Move a single word down to the next line")
});